export type ProfessionalHomeNavigationState = {
	openSession?: Sessions.Session;
	openProntuario?: OpenProntuarioNavigationState;
};

export type OpenProntuarioNavigationState = {
	patientId: string;
	medicalRecordSessionId: string;
	platformSessionId: string;
};

export const getProfessionalHomeOpenProntuario = (
	state: unknown,
): OpenProntuarioNavigationState | null => {
	if (!state || typeof state !== 'object') return null;

	const openProntuario = (state as ProfessionalHomeNavigationState)
		.openProntuario;
	if (
		!openProntuario ||
		typeof openProntuario !== 'object' ||
		typeof openProntuario.patientId !== 'string' ||
		typeof openProntuario.medicalRecordSessionId !== 'string' ||
		typeof openProntuario.platformSessionId !== 'string'
	) {
		return null;
	}

	return openProntuario;
};

export const getProfessionalHomeOpenSession = (
	state: unknown,
): Sessions.Session | null => {
	if (!state || typeof state !== 'object') return null;

	const session = (state as ProfessionalHomeNavigationState).openSession;
	if (
		!session ||
		typeof session !== 'object' ||
		typeof session.id !== 'string'
	) {
		return null;
	}

	return session;
};
